import React from 'react'
import AboutHeroSection from './AboutHeroSection'
import AboutSecondSection from './AboutSecondSection'
import CounterSection from './CounterSection'
import ProcessSection from './ProcessSection'
import TeamSection from '../HomePage/TeamSection'
import WhyChooseSection from './WhyChooseSection'
import TestimonialsSection from '../HomePage/TestimonialsSection'
import TrustedSection from '../HomePage/TrustedSection'

const AboutUsPage = () => {
  return (
    <div>
        <AboutHeroSection pageName={"About Us"}/>
        <AboutSecondSection/>
        <CounterSection/>
        <ProcessSection/>
        <TeamSection/>
        <WhyChooseSection/>
        <TestimonialsSection/>
        <TrustedSection/>
    </div>
  )
}

export default AboutUsPage